import { render, staticRenderFns } from "./PassportIndicatorEditButton.vue?vue&type=template&id=b4af53d6"
import script from "./PassportIndicatorEditButton.vue?vue&type=script&lang=js"
export * from "./PassportIndicatorEditButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports